import silverTheme from "../../../../theme";

export const snackbarStyles = {
  "& .MuiLink-root": {
    color: silverTheme.paleta.gris100,
    fontSize: 14,
    paddingRight: silverTheme.spacing(1.5),
    fontWeight: 400,
    letterSpacing: "normal",
    cursor: "pointer",
    textDecorationColor: silverTheme.paleta.gris100,
  },
  "& .MuiButton-root": {
    color: silverTheme.paleta.gris100,
    fontSize: 14,
    fontWeight: 400,
    letterSpacing: "normal",
    "&:hover": {
      backgroundColor: "transparent",
      color: silverTheme.paleta.gris100,
    },
  },
  "& .MuiIconButton-root": {
    color: silverTheme.paleta.gris100,
    fontSize: 14,
    fontWeight: 400,
    letterSpacing: "normal",
    "&:hover": {
      backgroundColor: "transparent",
      color: silverTheme.paleta.gris100,
    },
  },
  "& .SnackbarItem-variantSuccess": {
    backgroundColor: silverTheme.paleta.success30,
  },
  "& .SnackbarItem-variantInfo": {
    backgroundColor: silverTheme.paleta.info30,
  },
  "& .SnackbarItem-variantError": {
    backgroundColor: silverTheme.paleta.error30,
  },
  "& .SnackbarItem-variantWarning": {
    backgroundColor: silverTheme.paleta.warning30,
    color: silverTheme.paleta.gris0,
  },
};

export default snackbarStyles;
